<template>
  <date-picker
    v-model="modelValue"
    :type="type"
    :valueType="valueType"
    :input-attr="inputAttributes"
    :minute-step="10"
    :show-second="false"
    :show-time-panel="showTimePanel"
    :lang="lang"
    @close="onClose">
    <template v-slot:footer>
      <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
        {{ btnText }}
      </button>
    </template>
  </date-picker>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  name: 'DateTimeInput',
  components: {
    DatePicker,
  },

  data: function() {
    return {
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
          weekdaysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
          monthsShort: ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'],
        },
        monthBeforeYear: false,
      },

      showTimePanel: false,
    };
  },

  props: {
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    value: {},

    type: {
      type: String,
      default: 'datetime',
    },
    valueType: {
      type: String,
      default: 'timestamp',
    },
  },

  computed: {
    inputAttributes() {
      return {
        id: this.id,
        name: this.name,
      };
    },

    modelValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },

    btnText() {
      return this.showTimePanel ? 'select date' : 'select time';
    },
  },

  methods: {
    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },

    onClose() {
      this.showTimePanel = false;
    },
  },
};
</script>

<style scoped>
/* override default datepicker display property */
.mx-datepicker {
  display: block;
}
</style>